import { render, staticRenderFns } from "./WorkbenchNavGuild.vue?vue&type=template&id=41069aa2&scoped=true"
import script from "./WorkbenchNavGuild.vue?vue&type=script&lang=js"
export * from "./WorkbenchNavGuild.vue?vue&type=script&lang=js"
import style0 from "./WorkbenchNavGuild.vue?vue&type=style&index=0&id=41069aa2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41069aa2",
  null
  
)

export default component.exports